import React, { useEffect } from "react";
import { Button, DetailCard } from "../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { fetchSavedHistoryStart } from "../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { convertFromUTC } from "../../../../utils/dateUtils";

const SavedHistory = ({ board, subBoard, onSelect, onClick }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const data = useSelector((state) => {
    if (board === "monster" && subBoard) {
      //console.log(state.bdmJobs.jobBoards.monster?.[subBoard])
      return (
        state.bdmJobs.jobBoards.monster?.[subBoard]?.recentHistory?.data || []
      );
    }
    return state.bdmJobs.jobBoards?.[board]?.recentHistory?.data || [];
  });
  useEffect(() => {
    const sourceMapping = {
      internalDb: 1,
      careerBuilder: 2,
      // monster: 3,
      monster: {
        classic: 3,
        power: 4,
        monster: 5,
      },
      // kultSearch: 6,
      integratedSearch: 6,
    };
    const source =
      board === "monster" && subBoard
        ? sourceMapping.monster[subBoard]
        : sourceMapping[board];

    const params = {
      lim: 10,
      pg: 1,
      fil: {
        // source: { type: "IN", value: [source] },
        source: { type: "NONE", value: source },
        // status: 2, // saved 
        status: { type: "NONE", value: 2 }, // saved 
        addedBy: { type: "NONE", value: user?.data?.uiid }
      },
      sort: { addedOn: 1 }
    };
    // dispatch(fetchRecentHistoryStart({ board, params, isRecent: false }));
    dispatch(fetchSavedHistoryStart({ board, subBoard, params, isRecent: true }));
  }, [board, dispatch, subBoard]);
  if (!data || data.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">
        No saved history found.
      </div>
    );
  }
  const safeDecode = (v) => {
    try {
      return typeof v === "string" ? decodeURIComponent(v) : v;
    } catch {
      return v;
    }
  };


  const getTitle = (item) => {
    const q = item?.query ?? {};

    const fromOther =
      (q?.bkeyword?.[0]?.jobTitle && safeDecode(String(q.bkeyword[0].jobTitle).trim())) ||
      (q?.bkeyword && (Array.isArray(q.bkeyword) ? safeDecode(q.bkeyword.trim()) : safeDecode(String(q.bkeyword).trim()))) ||
      (q?.q || safeDecode(q?.jt) || q?.bkeyword) ||
      (q?.Keywords && String(q.Keywords).trim()) || (q?.keywords && String(q.keywords).trim()) || (q?.monster?.q);

    const mustFlattened = [
      ...((q?.bool?.must?.[0]?.bool?.must || q?.bool?.must?.[0]?.bool?.should) ?? []),
      ...(q?.bool?.must ?? [])
    ];

    const must = ((q?.bool?.must?.[0]?.bool?.must || q?.bool?.must?.[0]?.bool?.should) && q?.bool?.must)
      ? mustFlattened
      : (q?.bool?.must?.[0]?.bool?.should ?? q?.bool?.must ?? []);
    const terms = Array.isArray(must)
      ? must
        .map((m) =>
          m?.match_phrase?.htmlResume ??
          m?.match?.htmlResume ??
          m?.query?.htmlResume ??
          null
        )
        .filter(Boolean) // remove undefined/null/empty
      : [];

    const joinedTerms = terms.length ? terms.join(" ").trim() : "";
    const title = (fromOther && fromOther) || (joinedTerms && joinedTerms) || "-";

    return title
  };

  const getFilterTermsInternalBD = (item) => {
    const filterTerms = item?.query ?? {};
    return filterTerms
  }

  const getFilterTermsCareerBuilder = (item) => {
    const filterTerms = item?.query ?? {};
    return filterTerms
  }

  const getFilterTermsMonster = (item) => {
    const filterTerms = item?.query ?? {};
    return filterTerms
  }


  const getFilterTermsIntegratedSearch = (item) => {
    const filterTerms = item?.query ?? {};
    return filterTerms
  };


  const handlerMap = {
    internalDb: getFilterTermsInternalBD,
    careerBuilder: getFilterTermsCareerBuilder,
    monster: getFilterTermsMonster,
    integratedSearch: getFilterTermsIntegratedSearch
  };

  return ((data) || []).map((item, j) => {
    const title = getTitle(item);
    const filterFn = handlerMap[board];
    const filterTerms = typeof filterFn === "function" ? filterFn(item) : null;
    const isDisabled = title === "-";

    return (
      <div className="m-3" key={item._id || j}>
        <DetailCard
          size="xs"
          title={
            <div className="flex items-center gap-2">
              <span className="material-symbols-outlined !text-lg">alarm_add</span>
              <div className="font-bold text-xs">{convertFromUTC(item.addedOn)}</div>
            </div>
          }
          headeRight={
            <div className="flex items-center">
              <Button
                icon="edit_square"
                variant="text"
                type="icon"
                disabled={isDisabled}
                size="sm"
                onClick={() => onSelect?.({ title, filterTerms })}
                color="black"
              />
              {/* <Button
                icon="save"
                variant="text"
                type="icon"
                disabled={isDisabled}
                size="sm"
                onClick={() => { handleSaveHistory(item);  }} //setItemToRemove(item?.addedOn)
                color="black"
              /> */}
            </div>
          }
        >
          <div className="my-2 mx-1 text-sm">
            <button
              onClick={() => {
                onSelect?.({ title, filterTerms });
                onClick?.({ title, filterTerms });
              }}
              className="relative text-black font-medium hover:text-blue-500 after:absolute after:left-0 after:-bottom-1 after:h-0.5 after:w-full after:bg-blue-500 after:scale-x-0 hover:after:scale-x-100 after:origin-left after:transition-transform after:duration-300"
            >
              {title}
            </button>
          </div>
        </DetailCard>
      </div>
    );
  });

};


export default SavedHistory;
